import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientFeedbackPage from "@/pages/client/ClientFeedbackPage";

export const Route = createFileRoute("/client/feedback")({
  head: () => pageHead("Client · Feedback", "AKIVA client · feedback portal.", "/client/feedback", true),
  component: ClientFeedbackPage,
});
